import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ResultDropdownDeleteButton } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultDropdownDeleteButton";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Opacity } from "@faire/web--source/slate/Color";
import { Label } from "@faire/web--source/slate/Filter/styled";
import { Flex } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import * as React from "react";
import styled from "styled-components";
export var ImageSearchPill = function(param) {
    var suggestion = param.suggestion, onClick = param.onClick, onHover = param.onHover, onMouseLeave = param.onMouseLeave, selected = param.selected, onDelete = param.onDelete, _param_isDeleting = param.isDeleting, isDeleting = _param_isDeleting === void 0 ? false : _param_isDeleting, svgIcon = param.svgIcon, url = param.url, dataTestId = param.dataTestId;
    var _suggestion_searchData_image, _suggestion_searchData;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isSSR = useIsSSR();
    var _optimizeImageUrl;
    return /*#__PURE__*/ _jsxs(Pill, {
        selected: selected,
        onMouseEnter: onHover,
        onMouseLeave: onMouseLeave,
        onClick: isDeleting ? undefined : onClick,
        to: url,
        "data-test-id": dataTestId,
        children: [
            svgIcon ? /*#__PURE__*/ _jsx(SVGIconWrapper, {
                color: Core.icon.default,
                children: svgIcon
            }) : /*#__PURE__*/ _jsx(Avatar, {
                $avatarImageUrl: (_optimizeImageUrl = optimizeImageUrl({
                    url: (_suggestion_searchData = suggestion.searchData) === null || _suggestion_searchData === void 0 ? void 0 : (_suggestion_searchData_image = _suggestion_searchData.image) === null || _suggestion_searchData_image === void 0 ? void 0 : _suggestion_searchData_image.url
                }, isSSR, {
                    height: 32,
                    width: 32,
                    resizeMethod: "fill"
                })) !== null && _optimizeImageUrl !== void 0 ? _optimizeImageUrl : ""
            }),
            /*#__PURE__*/ _jsx(Label, {
                children: suggestion.label
            }),
            onDelete ? /*#__PURE__*/ _jsx(StyledDeleteButton, {
                onDelete: onDelete,
                isDeleting: isDeleting,
                ariaLabel: strictLocalize({
                    id: "wlZjqN",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Delete \""
                        },
                        {
                            type: 1,
                            value: "labelFullyTranslatedSentence"
                        },
                        {
                            type: 0,
                            value: "\" search query"
                        }
                    ]
                }, {
                    labelFullyTranslatedSentence: suggestion.label
                })
            }) : /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            })
        ]
    });
};
var Pill = styled(Link).withConfig({
    componentId: "sc-4311bf46-0"
})([
    "display:flex;align-items:center;border-radius:20px;cursor:pointer;height:40px;margin:4px;background-color:",
    ";&:hover{background-color:",
    ";}&:focus-visible{outline:auto;outline:2px solid -webkit-focus-ring-color;outline-offset:2px;}"
], function(param) {
    var selected = param.selected;
    return selected ? Core.surface.subdued : Core.surface.subdued + Opacity.O_50;
}, Core.surface.subdued);
var Avatar = styled.div.withConfig({
    componentId: "sc-4311bf46-1"
})([
    "width:32px;height:32px;margin:4px 8px 4px 4px;border-radius:100%;background-position:center;background-size:cover;background-image:url(",
    ");"
], function(props) {
    return props.$avatarImageUrl;
});
var StyledDeleteButton = styled(ResultDropdownDeleteButton).withConfig({
    componentId: "sc-4311bf46-2"
})([
    "display:flex;align-items:center;justify-content:center;margin:",
    ";border-radius:50%;height:28px;width:28px;&:hover{background-color:",
    ";}"
], getSpacing(0, "1x"), Core.surface.subdued);
var SVGIconWrapper = styled(Flex).attrs({
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-4311bf46-3"
})([
    "height:28px;width:28px;margin:",
    ";border-radius:50%;"
], getSpacing(0, "1x"));
